import {
	Button,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react"
import { FC, useRef } from "react"
import { BsPrinterFill } from "react-icons/bs"
import ReactToPrint from "react-to-print"
import { IExpense } from "src/domain/entities"
import { ExpensePrintView } from "./ExpensePrintView"

interface Props {
	expense: IExpense
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
}

export const ExpensePreviewDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	expense,
}) => {
	const onClose = () => setIsOpen(false)

	const printComponentRef = useRef<HTMLDivElement>(null)

	return (
		<>
			<Modal onClose={onClose} isOpen={isOpen} isCentered size={"3xl"}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Expense Preview</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<ExpensePrintView expense={expense} />
					</ModalBody>
					<ModalFooter>
						<Flex gridColumnGap={2}>
							<Button onClick={onClose}>Close</Button>
							<div ref={printComponentRef} className="printable">
								<ExpensePrintView expense={expense} />
							</div>
							<ReactToPrint
								content={() => printComponentRef.current}
								copyStyles={true}
								trigger={() => (
									<Button
										colorScheme={"green"}
										leftIcon={<BsPrinterFill />}
									>
										Print
									</Button>
								)}
							/>
						</Flex>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	)
}
